import { render } from "./AiModuleList.vue?vue&type=template&id=00f17ca5&scoped=true&ts=true"
import script from "./AiModuleList.vue?vue&type=script&lang=ts"
export * from "./AiModuleList.vue?vue&type=script&lang=ts"

import "./AiModuleList.vue?vue&type=style&index=0&id=00f17ca5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f17ca5"]])

export default __exports__